<template>
  <div>
    <v-layout column>
      <HeaderBar>
        Employee Watch Lists
        <template slot="buttons">
          <v-btn @click="showNewList = true" color="success">
            <v-icon left>
              add
            </v-icon>
            Create List
          </v-btn>
        </template>
      </HeaderBar>


      <v-progress-linear indeterminate v-if="pending" />
      <v-flex v-else>
        <v-data-table
          :items="lists"
          item-key="id"
          :headers="[
            { text: 'Name', value: 'name' },
            { text: 'Employee Count', value: 'employeeCount' },
            { },
          ]"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'employeeWatchList', params: { listID: item.id } }">{{ item.name }}</router-link>
              </td>
              <td>
                {{ item.employeeCount }}
              </td>
              <td style="text-align: right;">
                <v-btn @click="destroyList(item.id)" icon color="error" flat>
                  <v-icon>
                    delete
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showNewList" max-width="400">
      <v-card>
        <v-card-title class="headline"
          >Create new list</v-card-title
        >

        <v-card-text>
          <v-text-field
            label="List name"
            v-model="newName"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="showNewList = false"
            >Nevermind</v-btn
          >
          <v-btn
            color="success"
            @click="createList"
            :disabled="newCallPending || newName === ''"
            :loading="newCallPending"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import employeeWatchListAPI from '@/api/employeeWatchList'

export default {
  data() {
    return {
      lists: [],
      pending: false,
      newName: '',
      showNewList: false,
      newCallPending: false,
    }
  },
  created() {
    this.pending = true
    employeeWatchListAPI.getAll((r) => {
      this.lists = r
      this.pending = false
    })
  },

  methods: {
    createList() {
      employeeWatchListAPI.create({
        name: this.newName
      }, (r) => {
        this.lists.push(r)
        this.newName = ""
        this.showNewList = false
      }, (e) => {
        this.$store.dispatch('global/showSnackbarError', { message: "Something went wrong creating that list" })
      })
    },

    destroyList(id) {
      employeeWatchListAPI.destroy({
        listID: id
      }, (r) => {
        this.lists = this.lists.filter((l) => l.id != id)
      }, (e) => {
        this.$store.dispatch('global/showSnackbarError', { message: "Something went wrong deleting that list" })
      })
    },
  }
}
</script>
